import styled from "styled-components";

export const TermosContainer = styled.div`  
    background-color: var(--primary-color);
    padding: 20px;
    box-sizing: border-box;
    
    .content{
        box-sizing: border-box;
        background-color: white;
        display: flex;
        flex-direction: column;
        border-radius: 10px;
        height: calc(100vh - 40px);

        .image{
            width: 100px;
            align-self: center;
            margin-bottom: 20px;
        }
    }
`